/**
 * 判断基金类型
 */
// eslint-disable-next-line import/no-unresolved
import store from '../store/index';
import QuestionModel from '../model/question.model';

class StoreManger {
  static getFundMain() {
    const fundData = store.state.baseInfo.fund[`newdate${store.state.native.fund.fundCode}`];
    if (fundData) {
      return fundData;
    }
    return null;
  }

  static getFundMainData() {
    const fundData = store.state.baseInfo.fund[`${store.state.native.fund.fundCode}`];
    if (fundData) {
      return fundData;
    }
    return null;
  }

  static getFundHkMainData() {
    const fundData = store.state.quotation.fund[`${store.state.native.fund.fundCode}updateFundMNStopWatch`];
    if (fundData && fundData.Datas) {
      return fundData.Datas;
    }
    return null;
  }

  static getFundJJXQNAME(baseInfo) { // 主数据
    let name = '';
    if (baseInfo && baseInfo.SHORTNAME) {
      name = baseInfo.SHORTNAME;
    }
    return name;
  }

  static getFundJJXQCODE(baseInfo) { // 主数据
    let code = '';
    if (baseInfo && baseInfo.FCODE) {
      code = baseInfo.FCODE;
    }
    return code;
  }

  static getFundJJXQ() { // 主数据
    const fundDatamain = store.state.quotation.fund[`${store.state.native.fund.fundCode}fundbaseinfos`];
    const fundData = this.getFundMain();
    if (fundDatamain && fundDatamain.data) {
      const { data } = fundDatamain;
      if ((data && Object.prototype.toString.call(data) === '[object Array]' && data.length > 0)) {
        const item = data[0];
        const {
          FINSALES,
          ISSBDATE,
          ISSEDATE,
          ISSALES,
          ISBUY,
          RGBEGIN,
          RGEND,
        } = item;
        let BUY = false;
        if (ISBUY === '1' || ISBUY === '2' || ISBUY === '3' || ISBUY === '8' || ISBUY === '9') {
          BUY = true;
        }
        let btime = `${ISSBDATE} 00:00:00`;
        let etime = `${ISSEDATE} 15:00:00`;
        if (RGBEGIN !== '' && RGBEGIN !== '--') {
          btime = RGBEGIN;
        }
        if (RGEND !== '' && RGEND !== '--') {
          etime = RGEND;
        }
        if (fundData && fundData.JJXQ && fundData.JJXQ.Datas) {
          if (fundData && fundData.JJMB && fundData.JJMB.Datas) {
            const mb = fundData.JJMB.Datas;
            const sType = `${mb.P}_${mb.T}_${mb.F}`;
            if (/.*_.*_.*N.*/.test(sType)) {
              // 新发
              fundData.JJXQ.Datas.ISSALES = ISSALES;
              fundData.JJXQ.Datas.FINSALES = FINSALES;
              fundData.JJXQ.Datas.BUY = BUY;
              fundData.JJXQ.Datas.ISSBDATE = btime;
              fundData.JJXQ.Datas.ISSEDATE = etime;
              return fundData.JJXQ.Datas;
            }
          }
        }
      }
    }
    if (fundData && fundData.JJXQ && fundData.JJXQ.Datas) {
      return fundData.JJXQ.Datas;
    }
    return {
      FCODE: '',
      SHORTNAME: '',
    };
  }

  static getFundJJTX() { // 基金提醒
    const fundData = this.getFundMain();
    if (fundData && fundData.JJTX && fundData.JJTX.Datas) {
      return fundData.JJTX.Datas;
    }
    return null;
  }

  static getFundJDZF() { // 阶段涨幅
    const fundData = this.getFundMain();
    if (fundData && fundData.JDZF) {
      return fundData.JDZF;
    }
    return null;
  }

  static getFundJJBQ() { // 行情标签
    const fundData = this.getFundMain();
    if (fundData && fundData.JJBQ) {
      return fundData.JJBQ;
    }
    return null;
  }

  static getFundJJFX() { // 行情分享信息
    const fundData = this.getFundMain();
    if (fundData && fundData.JJFX && fundData.JJFX.Datas) {
      return fundData.JJFX.Datas;
    }
    return null;
  }

  static getFundFHTS() { // 详情接口
    const fundData = this.getFundMain();
    if (fundData && fundData.FHTS && fundData.FHTS.Datas) {
      return fundData.FHTS.Datas;
    }
    return null;
  }

  static getFundJJJL() { // 基金经理
    const fundData = this.getFundMain();
    if (fundData && fundData.JJJL && fundData.JJJL.Datas) {
      return fundData.JJJL.Datas;
    }
    return null;
  }

  static getFundJJJLNew() { // 基金经理
    const fundData = this.getFundMain();
    if (fundData && fundData.JJJLNEW && fundData.JJJLNEW.Datas) {
      return fundData.JJJLNEW.Datas;
    }
    return null;
  }

  static getFundJJGM() { // 基金规模
    const fundData = this.getFundMain();
    if (fundData && fundData.JJGM) {
      return fundData.JJGM;
    }
    return null;
  }

  static getFundHBCC() { // 货币持仓
    const fundData = this.getFundMain();
    if (fundData && fundData.HBCC) {
      return fundData.HBCC;
    }
    return null;
  }

  static getFundFHSP() { // 分红
    const fundData = this.getFundMain();
    if (fundData && fundData.FHSP && fundData.FHSP.Datas) {
      return fundData.FHSP.Datas;
    }
    return null;
  }

  static getFundFHTX() { // 分红提醒
    const fundData = this.getFundMain();
    if (fundData && fundData.FHTX && fundData.FHTX.Datas) {
      return fundData.FHTX.Datas;
    }
    return null;
  }

  static getFundJJCC() { // 普通持仓
    const fundData = this.getFundMain();
    if (fundData && fundData.JJCC && fundData.JJCC.Datas) {
      return fundData.JJCC.Datas;
    }
    return null;
  }

  static getFundJJCCExpansion() { // 普通持仓 日期
    const fundData = this.getFundMain();
    if (fundData && fundData.JJCC && fundData.JJCC.Expansion) {
      return fundData.JJCC.Expansion;
    }
    return null;
  }

  static getNAVSTATEHEIGHT() { // 普通持仓 日期
///////////////////////////////////
////////////////////////////////////////
///////////////////////////////////////////////////
////////////////////////
////////////////////////////////////////////////////////////
/////////////////////////////////////
///////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////
////////////////////////////
////////
/////////////
/////////////
/////////////////////////////////
    // return 0;
/////////////
  }

  static getFundJJCCAssetExpansion() { // 普通持仓 日期
    const basedata = this.getFundJJCC();
    if (!basedata) {
      return '';
    }
    const holddate = this.getFundJJCCExpansion();
    const Asset = basedata.AssetAllocation;
    if (!holddate || !Asset) {
      return '';
    }
    let lastdate = holddate;
    if (Asset[holddate]) {
      return `${holddate}`;
    }
    Object.keys(Asset)
      .forEach((key) => {
        if (key > lastdate) {
          lastdate = key;
        }
        if (key < holddate) {
          lastdate = key;
        }
      });
    return `${lastdate}`;
  }

  static getFundBALIST() { // 基金吧列表
    const fundData = this.getFundMain();
    if (fundData && fundData.BALIST && fundData.BALIST.Data) {
      return fundData.BALIST.Data;
    }
    return null;
  }

  static getFundBAINFO() { // 基金问答
    const fundData = this.getFundMain();
    if (fundData && fundData.BAINFO && fundData.BAINFO.Data) {
      const a = {
        // eslint-disable-next-line max-len
        Data: QuestionModel.objectArrayWithKeyValuesArray(fundData.BAINFO.Data.QuestionTopList || []),
        VarietyDynamicStatistics: fundData.BAINFO.Data.VarietyDynamicStatistics,
        PostCount: fundData.BAINFO.Data.PostCount,
      };
      return a;
    }
    return null;
  }

  static getFundSPZH() { // 实盘组合
    const fundData = this.getFundMain();
    if (fundData && fundData.SPZH) {
      return fundData.SPZH;
    }
    return null;
  }

  static getFundTSSJ() { // 主数据
    const fundData = this.getFundMain();
    if (fundData && fundData.TSSJ && fundData.TSSJ.Datas) {
      return fundData.TSSJ.Datas;
    }
    return null;
  }

  static getFundMonery(Key) {
///////////////////////////////////
////////////////////////////////////////
/////////////////////////
//////////////////////////////////////////
///////////////////////////////////////
//////////////////////////////////////
///////////////////////////
//////////////////
////////////////////
///////
//////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////
/////////////////////
/////
/////////////
    return null;
  }

  static getFundLiveData() {
    // 直播数据有变化，老版本不显示了
    return null;
  }

  static getFundHoldList(uid) { // 持仓列表
    const nholdFundData = store.state.tradeInfo.fund[uid];
    if (nholdFundData && nholdFundData.Data && nholdFundData.Data.Funds) {
      const list = [];
      const dataLsit = nholdFundData.Data.Funds;
      if (dataLsit) {
        dataLsit.forEach((item) => {
          list.push(item.FundCode);
        });
      }
      return list;
    }
    return [];
  }

  static GetFundsProductProfit() { // 持仓列表
    const baseInfo = this.getFundJJXQ();
    const hdcode = baseInfo.BACKCODE;
    const qdcode = baseInfo.FCODE;
    if (hdcode && hdcode !== '--') {
      const data = store.state.tradeInfo.fund[`GetFundsProductProfit${qdcode},${hdcode}`];
      return data;
    }
    const data = store.state.tradeInfo.fund[`GetFundsProductProfit${qdcode}`];
    return data;
  }

  static GetFundsMB() { // 持仓列表
    const fundData = this.getFundMain();
    if (fundData && fundData.JJMB && fundData.JJMB.Datas) {
      return fundData.JJMB.Datas;
    }
    return null;
  }
}

export default StoreManger;
